import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { HEADER_BACKGROUND_BREAKPOINTS } from './constants';

import './HeaderBackground.scss';

const SIZES = `
(max-width: 660px) 490px,
(max-width: 1608px) 660px,
(max-width: 1920px) 1608px,
1920px
`;

const makeImageSetString = (imageSet) => {
    const defaultImage = imageSet.mobile;

    const setString = Object.keys(imageSet).reduce((acc, key) => {
        const fileName = imageSet[key];
        const width = HEADER_BACKGROUND_BREAKPOINTS[key] || 490;
        return (acc += `${fileName} ${width}w,`);
    }, '');

    return { default: defaultImage, srcSet: setString };
};

const MainHeaderBackgroundImageSet = ({ imageSet, placeholder }) => {
    const formattedImageSet = makeImageSetString(imageSet);

    return (
        <>
            <source
                media={`(max-width: ${HEADER_BACKGROUND_BREAKPOINTS['tablet']}px)`}
                srcSet={imageSet['mobile']}
            />
            <source
                media={`(min-width: ${HEADER_BACKGROUND_BREAKPOINTS['tablet']}px)`}
                srcSet={formattedImageSet.srcSet}
            />
            <img
                className="fullbleed-header__main-bg"
                src={formattedImageSet.default}
                srcSet={formattedImageSet.srcSet}
                sizes={SIZES}
                alt="Homepage header"
                style={{ backgroundColor: placeholder?.color }}
                importance="high"
            />
        </>
    );
};

export class FullbleedHeaderBackground extends Component {
    static propTypes = {
        headerImages: PropTypes.object,
    };

    render() {
        const { placeholder, headerImages } = this.props;

        return (
            <div className="fullbleed-header__main-bg-wrapper">
                <picture>
                    <MainHeaderBackgroundImageSet
                        imageSet={headerImages}
                        placeholder={placeholder}
                    />
                </picture>
            </div>
        );
    }
}

const _mapStateToProps = ({ header = {} }) => ({
    headerImages: header.images,
});

export default connect(_mapStateToProps)(FullbleedHeaderBackground);
